import { mergeRuleByModelSlice } from "./MergeRuleByModel.redux";


export const {
    updateMergeRuleByModel,
    updateMergeRulesByModel,
    addMergeRulesByModel,
    removeMergeRuleFromModel,
    removeMergeRuleFromModelList
} = mergeRuleByModelSlice.actions;